import { Select } from '@material-ui/core'
import { MenuItem } from 'material-ui'
import React from 'react'
import injectStyles from 'react-jss'
import styles from '../styles'

const VoQuizPartsView = ({
  setNumberOfQuestions,
  numberOfQuestions,
  onNumberOfQuestionsSave,
  classes,
  children,
}) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.title}>Video Onboarding Questions</div>
      <div className={classes.selectorContainer}>
        <div className={classes.selectTitle}>Number of questions:</div>
        <div className={classes.selector}>
          <Select
            labelId="demo-simple-select-filled-label"
            id="demo-simple-select-filled"
            className={classes.select}
            value={numberOfQuestions}
            onChange={event => setNumberOfQuestions(event.target.value)}
            disableUnderline={true}
          >
            <MenuItem value={null}>Select number</MenuItem>
            <MenuItem value={3}>3</MenuItem>
            <MenuItem value={4}>4</MenuItem>
            <MenuItem value={5}>5</MenuItem>
          </Select>
        </div>

        {!numberOfQuestions ? (
          <div className={classes.error}>Number of question is required</div>
        ) : (
          <div className={classes.button} onClick={onNumberOfQuestionsSave}>
            Save
          </div>
        )}
      </div>
      {children}
    </div>
  )
}

export default injectStyles(styles)(VoQuizPartsView)
